<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">search</i>
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('search.Search') }}</h6>
                        <div class="row" style="margin-top: -30px;">
                            <div class="col-lg-6">                                
                            </div>                               
                            <div class="col-lg-6 d-flex justify-content-end align-items-center gap-2">                                
                            </div>
                        </div>
                    </div>
                    <div class="row ms-3 me-4 mt-5">
                        <div class="col-lg-3"  v-if="userRoleName === 'Admin'">
                            <div class="input-group input-group-static null">
                                <label>{{ $t('user.Association') }} *</label>
                                <select id="associationId" :value="associationId" class="form-control form-control-default">
                                    <option value="">{{ $t('user.Select_association') }}</option>
                                    <option v-for="item in associations" :key="item.id" :value="item.id">
                                        {{ item.abbreviation }}
                                    </option>
                                </select>                                
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="input-group input-group-static null">
                                <label>{{ $t('animal.Breed') }}</label>  
                                <select id="breedId" v-model="this.breedId" class="form-control form-control-default" :disabled="!associationId">
                                    <option value="">{{ $t('animal.Select_breed') }}</option>
                                    <option v-for="item in this.breeds" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="input-group input-group-static null">
                                <label>{{ $t('search.Search_text') }} *</label>
                                <input id="searchText" v-model="searchText" type="text" class="form-control form-control-default" :placeholder="$t('search.Search')">            
                            </div>
                        </div>
                        <div class="col-lg-3 d-flex flex-column">
                            <div class="input-group input-group-static mt-auto">
                                <button v-on:click="searchDataAdmin" class="btn btn-sm bg-gradient-success">
                                    {{ $t('common.Search1') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <!-- LEFT : LOCATIONS -->
                        <div class="col-lg-6 col-md-12">
                            <div class="card shadow-sm mb-4">
                                <div class="card-header pb-0">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h6 class="mb-0">
                                            {{ $t('location.Locations') }}
                                        </h6>
                                        <span v-if="searchResults.length"
                                            class="badge bg-gradient-success">
                                            {{ searchResults.length }}
                                        </span>
                                    </div>
                                </div>
                                <div class="card-body pt-2" style="padding-right: 0.3rem !important;">
                                    <div class="table-responsive location-table">
                                        <table id="search-list" class="table table-flush" v-if="searchResults.length > 0">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('search.UBN') }}</p></th>
                                                    <!--th><p class="mb-0 text-xs font-weight-bold">{{ $t('search.Name') }}</p></th-->
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('search.Address') }}</p></th>
                                                    <!--th><p class="mb-0 text-xs font-weight-bold">{{ $t('search.Keeper') }}</p></th>
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('search.Phone_number') }}</p></th>
                                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('search.Email') }}</p></th-->
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in searchResults" v-bind:key="item.id" :class="{ 'selected-location': item.id === selectedLocationId }">  
                                                    <td class="text-sm font-weight-normal">
                                                        {{ item.ubn }}<br />
                                                        {{ $t('search.Name') }}: {{ item.name }}<br />
                                                        {{ $t('search.Keeper') }}: {{ item.keeperFullname }}<br />
                                                        {{ $t('search.Phone_number') }}: {{ item.keeperPhoneNumber }}<br />
                                                        {{ $t('search.Address') }}: {{ item.keeperEmail }}
                                                    </td>
                                                    <!--td class="text-sm font-weight-normal">{{ item.name }}</td-->
                                                    <td class="text-sm font-weight-normal" v-html="item.locationAddress"></td>
                                                    <!--td class="text-sm font-weight-normal">{{ item.keeperFullname }}</td>
                                                    <td class="text-sm font-weight-normal">{{ item.keeperPhoneNumber }}</td>
                                                    <td class="text-sm font-weight-normal">{{ item.keeperEmail }}</td-->
                                                    <td>
                                                        <div class="float-end">
                                                            <button                                                
                                                                class="btn btn-success animal-button shadow-sm"
                                                                :title="$t('animal.Animals')"
                                                                :data-location-id="item.id"
                                                            >
                                                                <img src="@/assets/img/animal.svg" class="animal-icon" />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-else
                                            class="text-muted text-sm text-center py-5">
                                            {{ $t('datatable.NoRows') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- RIGHT : ANIMALS -->
                        <div class="col-lg-6 col-md-12">
                            <div class="card shadow-sm mb-4">
                                <div class="card-header pb-0">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h6 class="mb-0">
                                            {{ $t('animal.Animals') }}
                                        </h6>
                                        <span v-if="searchAnimalResults.length" class="badge bg-gradient-success"> {{ searchAnimalResults.length }}</span>
                                    </div>
                                </div>
                                <div class="card-body pt-2" style="padding-right: 0.3rem !important;">
                                    <div class="animal-table">
                                        <table v-if="selectedLocationId"
                                            id="animal-list"
                                            class="table table-flush animal-table-fixed">

                                            <thead>
                                                <tr>
                                                    <th>{{ $t('animal.Studbooknumber') }}</th>
                                                    <th>{{ $t('animal.Tagnumber') }}</th>
                                                    <!--th>{{ $t('animal.Birth_date') }}</th>
                                                    <th>{{ $t('animal.Gender') }}</th>
                                                    <th>{{ $t('animal.Name') }}</th>
                                                    <th>{{ $t('animal.Breed') }}</th-->
                                                    <th>{{ $t('animal.Breeder') }}</th>
                                                </tr>
                                            </thead>

                                            <tbody id="animal-table-body"></tbody>

                                        </table>

                                        <div v-if="!selectedLocationId" class="text-muted text-center py-5">
                                            Kies een locatie om dieren te tonen.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import * as Choices from "choices.js";
import axios from 'axios';
import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";

export default {
    name: 'Search_index_page',
    components: {        
    },
    data() {
        return {            
            gets: [],
            associationId: '',
            associations: [],
            breedId: '',
            breeds: [],
            searchText: '',
            searchResults: [],
            selectedLocationId: null,
            searchAnimalResults: [],
            locationDataTableInstance: null,
            animalDataTableInstance: null,            
            hover: false,
            associationChoicesInstance: null,
            breedChoicesInstance: null,
        }
    },    
    watch: {
        associationId(newVal) {
            if (this.userRoleName === 'Admin' && newVal) {
                this.fetchAllBreedData();
            }
        },
        '$route.query': {
            handler() {
                if (this.$route.name !== 'Search') return;

                const storedQuery = sessionStorage.getItem('searchQuery');
                if (storedQuery) {
                    const parsed = JSON.parse(storedQuery);

                    this.associationId = parsed.associationId;
                    this.searchText = parsed.searchText;
                    this.breedId = parsed.breedId;
                }

                const role = this.$store.state.roleName;
                if (role !== 'Admin' && this.associationId !== '' && this.searchText !== '') {
                    this.searchLocationData(this.associationId, this.searchText, this.breedId);
                }
            },
            immediate: true,
            deep: false
        },
    },
    computed: {
        userRoleName() {
            return this.$store.state.user?.roleName;
        },
        isKeeperOrInspector() {
            const role = this.$store.state.roleName;
            return role === "Keeper" || role === "Inspector";
        }
    },
    async mounted() {
        if (this.isKeeperOrInspector) {
            this.associationId = this.$store.state.keeperAssociationId;
            await this.fetchAllBreedData();
        } else {
            await this.fetchAllAssociationData();
            if (this.associationId) {
                await this.fetchAllBreedData();
            }
        }
    },
    methods: { 
        async searchDataAdmin() {
            await this.searchLocationData(this.associationId, this.searchText, this.breedId);
        }, 
        async searchLocationData(associationId = '', searchText = '', breedId = '') {
            await this.processSearchLocationData(associationId, searchText, breedId);            
        },        
        async fetchAllAssociationData() {

            this.$store.commit('setShowLoading', true);
            try {

                const response = await axios.get("association/getall");
                const result = response.data;

                if (result.success && Array.isArray(result.data.associationList)) {
                    this.associations = result.data.associationList;

                    this.$nextTick(() => {
                        this.initializeChoicesDropdown({
                            elementId: 'associationId',
                            options: this.associations,
                            modelKey: 'associationId',
                            instanceKey: 'associationChoicesInstance'
                        });
                    });                    
                } else {
                    this.$showError('errors.Error_fetching_association');
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        async fetchAllBreedData() {            
            this.$store.commit('setShowLoading', true);
            try {
                const response = await axios.get(`breed/getbyassociation?associationId=${this.associationId}`);
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    this.breeds = result.data;

                    this.$nextTick(() => {
                        this.initializeChoicesDropdown({
                            elementId: 'breedId',
                            options: this.breeds,
                            modelKey: 'breedId',
                            instanceKey: 'breedChoicesInstance'
                        });
                    });
                } else {    
                    this.$showError('errors.Error_fetching_breeds');
                }
            } catch (e) {                    
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        initializeChoicesDropdown({ elementId, options, modelKey, instanceKey }) {
            const element = document.getElementById(elementId);
            if (!element) return;

            // Destroy existing Choices instance if any
            if (this[instanceKey]) {
                this[instanceKey].destroy();
                this[instanceKey] = null;
            }

            // Create new instance
            this[instanceKey] = new Choices(element, {
                searchEnabled: false,
                shouldSort: false,
                placeholder: true,
            });

            // Add change listener to update the Vue model
            element.addEventListener("change", (event) => {
                this[modelKey] = event.target.value;
            });

            // Set selected value if it exists in options
            if (Array.isArray(options) && options.length > 0 && this[modelKey]) {
                const exists = options.some(item => item.id === this[modelKey]);
                this[instanceKey].setChoiceByValue(exists ? [this[modelKey]] : ['']);
            }
        },
        async processSearchLocationData(associationId, searchText, breedId) {
            this.$store.commit('setShowLoading', true);

            try {
                // Destroy old DataTable instance
                if (this.locationDataTableInstance) {
                    this.locationDataTableInstance.destroy();
                    this.locationDataTableInstance = null;
                }

                if (!associationId) {
                    this.$showError('errors.No_association_found');
                    this.searchResults = [];
                    await nextTick(); // ensures v-if removes the table
                    return;
                }

                if (!searchText) {
                    this.$showError('errors.Search_text_required');
                    this.searchResults = [];
                    await nextTick();
                    return;
                }

                const formData = { associationId, searchText, breedId };
                const response = await axios.get('Search/locations', { params: formData });
                const result = response.data;

                if (!result.success || !Array.isArray(result.data)) {
                    this.searchResults = [];
                    await nextTick();
                    this.$showError('errors.No_search_result_found');
                    return;
                }

                const dataList = result.data;

                if (dataList.length === 0) {
                    this.searchResults = [];
                    await nextTick();
                    this.$showError('errors.No_search_result_found');
                    return;
                }

                this.searchResults = dataList;

                await nextTick(); // wait for DOM to render table again
                this.initializeLocationDataTable();

            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },       
        async processSearchAnimalData(associationId, searchText, breedId, locationId) {
            this.$store.commit('setShowLoading', true);

            try {                
                // CLEAR ROWS FIRST
                this.searchAnimalResults = [];
                await nextTick();

                const formData = { associationId, searchText, breedId, locationId };
                const response = await axios.get('Search/animals', { params: formData });

                const result = response.data;

                if (!result.success || !Array.isArray(result.data)) {
                    this.searchAnimalResults = [];
                    return;
                }

                this.searchAnimalResults = result.data;

                await nextTick();

                // REINITIALIZE DATATABLE
                this.initializeAnimalDataTable();

            } catch (e) {

                const errorMessage = e.response?.data?.message || e.message;
                this.$showError(errorMessage);

            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        initializeLocationDataTable() {
            const tableEl = document.querySelector("#search-list");

            if (!tableEl) {
                console.warn("Table element not found in DOM");
                return;
            }

            try {
                // Extra safety check before (re)initializing
                if (this.locationDataTableInstance) {
                    this.locationDataTableInstance.destroy();
                    this.locationDataTableInstance = null;
                }

                this.locationDataTableInstance = new DataTable("#search-list", {
                    searchable: false,
                    fixedHeight: false,
                    perPageSelect: false,
                    columns: [
                        { select: 0, sortable: true },  
                        { select: 1, sortable: true },  
                        //{ select: 2, sortable: true },  
                        //{ select: 3, sortable: true },  
                        //{ select: 4, sortable: true },  
                        //{ select: 5, sortable: true },
                        { select: 2, sortable: false }
                    ],
                    labels: {
                        search: this.$t('datatable.Search'),
                        perPage: this.$t('datatable.PerPage'),
                        noRows: this.$t('datatable.NoRows'),
                        info: "Tonen {start} t/m {end} van {rows} items",
                        placeholder: this.$t('common.Search')
                    }
                });

                this.attachAnimalButtonEvents();
            } catch (err) {
                console.error('Error initializing DataTable:', err);
            }
        },
        async loadAnimals(locationId) {

            this.selectedLocationId = locationId;

            if (this.animalDataTableInstance) {
                this.animalDataTableInstance.destroy();
                this.animalDataTableInstance = null;
            }

            this.searchAnimalResults = [];

            await this.processSearchAnimalData(
                this.associationId,
                this.searchText,
                this.breedId,
                locationId
            );

            document.querySelector("#animal-list")?.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        },
        attachAnimalButtonEvents() {

            const table = document.querySelector("#search-list");

            if (!table) return;

            table.onclick = async (e) => {

                const btn = e.target.closest(".animal-button");
                if (!btn) return;

                const locationId = btn.dataset.locationId;

                if (!locationId) return;

                document.querySelectorAll("#search-list tbody tr")
                    .forEach(tr => tr.classList.remove("selected-location"));

                const row = btn.closest("tr");
                if (row) row.classList.add("selected-location");

                await this.loadAnimals(locationId);
            };
        },
        initializeAnimalDataTable() {

            const table = document.querySelector("#animal-list");
            const tbody = document.querySelector("#animal-table-body");

            if (!table || !tbody) return;

            tbody.innerHTML = "";

            const tName = this.$t('animal.Name');
            const tBirthDate = this.$t('animal.Birth_date');
            const tGender = this.$t('animal.Gender');
            const tBreed = this.$t('animal.Breed');

            this.searchAnimalResults.forEach(animal => {

                const row = document.createElement("tr");

                row.innerHTML = `
                    <td class="text-sm font-weight-normal">
                        ${animal.studbookNumber ?? ""} <br/>
                        ${tName}: ${animal.name ?? ""}<br/>
                        ${tBirthDate}: ${animal.birthDate ?? ""}<br/>
                        ${tGender}: ${animal.gender ?? ""}<br/>
                        ${tBreed}: ${animal.breed ?? ""}
                    </td>

                    <td class="text-sm font-weight-normal">
                        ${animal.tagNumber ?? ""}
                    </td>

                    <td class="text-sm font-weight-normal">
                        ${animal.breederName ?? ""}
                    </td>
                `;

                tbody.appendChild(row);
            });

            if (this.animalDataTableInstance) {
                this.animalDataTableInstance.destroy();
                this.animalDataTableInstance = null;
            }

            this.animalDataTableInstance = new DataTable("#animal-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: true },
                    { select: 2, sortable: true }                    
                ],
                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search')
                }
            });
        },          
    }
}
</script>
<style scoped>
    .table-responsive {
        overflow-x: auto;
        overflow-y: visible;
    }

    .choices {
        margin-bottom: 0px !important;
    }

    .custom-association-dropdown {        
        border: 1px solid #4ca750;
    }

    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }

    .animal-button {
        width: 32px;
        height: 30px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
    }

    .animal-icon {
        width: 10px;
        height: 10px;
        filter: brightness(0) invert(1); /* makes icon white */
    }

    .selected-location {
        background-color: #e8f5e9;
        border-left: 4px solid #4caf50;
        transition: background 0.2s ease;
    }

    .location-table,
    .animal-table {
        width: 100%;
        overflow-x: auto;
        margin-left: -25px;
    }

    ::v-deep .dataTable-table thead th {
        color: #344767 !important;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        background: #f8f9fa;
        border-bottom: 2px solid #e9ecef;
    }
    
    ::v-deep .dataTable-table tbody tr:hover {
        background-color: #f5f7fa;
    }

    ::v-deep .dataTable-sorter::after {
        margin-left: 6px;
    }

    
    ::v-deep .dataTable-table tbody td {
        vertical-align: top !important;
    }
</style>